const promiseWrapper = (promise, ...args) => {
    return promise(...args)
        .then(data => ({isSuccess: true, data: data}))
        .catch(error => ({isSuccess: false, data: error.response && error.response.data ? error.response.data : error}))
};

export default promiseWrapper;
